'use strict';

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var TimeoutController = require('timeout-abort-controller');

var anySignal = require('any-signal');

var parseDuration = require('parse-duration');

var errors = require('./errors.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var TimeoutController__default = /*#__PURE__*/_interopDefaultLegacy(TimeoutController);

var parseDuration__default = /*#__PURE__*/_interopDefaultLegacy(parseDuration);

function withTimeoutOption(fn, optionsArgIndex) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var options = args[optionsArgIndex == null ? args.length - 1 : optionsArgIndex];
    if (!options || !options.timeout) return fn.apply(void 0, args);
    var timeout = typeof options.timeout === 'string' ? parseDuration__default["default"](options.timeout) : options.timeout;
    var controller = new TimeoutController__default["default"](timeout);
    options.signal = anySignal.anySignal([options.signal, controller.signal]);
    var fnRes = fn.apply(void 0, args);
    var timeoutPromise = new Promise(function (_resolve, reject) {
      controller.signal.addEventListener('abort', function () {
        reject(new errors.TimeoutError());
      });
    });
    var start = Date.now();

    var maybeThrowTimeoutError = function maybeThrowTimeoutError() {
      if (controller.signal.aborted) {
        throw new errors.TimeoutError();
      }

      var timeTaken = Date.now() - start;

      if (timeTaken > timeout) {
        controller.abort();
        throw new errors.TimeoutError();
      }
    };

    if (fnRes[Symbol.asyncIterator]) {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var it, _yield$_awaitAsyncGen, value, done;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                it = fnRes[Symbol.asyncIterator]();
                _context.prev = 1;

              case 2:
                if (!true) {
                  _context.next = 15;
                  break;
                }

                _context.next = 5;
                return _awaitAsyncGenerator(Promise.race([it.next(), timeoutPromise]));

              case 5:
                _yield$_awaitAsyncGen = _context.sent;
                value = _yield$_awaitAsyncGen.value;
                done = _yield$_awaitAsyncGen.done;

                if (!done) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("break", 15);

              case 10:
                maybeThrowTimeoutError();
                _context.next = 13;
                return value;

              case 13:
                _context.next = 2;
                break;

              case 15:
                _context.next = 21;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](1);
                maybeThrowTimeoutError();
                throw _context.t0;

              case 21:
                _context.prev = 21;
                controller.clear();

                if (it.return) {
                  it.return();
                }

                return _context.finish(21);

              case 25:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 17, 21, 25]]);
      }))();
    }

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var res;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return Promise.race([fnRes, timeoutPromise]);

            case 3:
              res = _context2.sent;
              maybeThrowTimeoutError();
              return _context2.abrupt("return", res);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);
              maybeThrowTimeoutError();
              throw _context2.t0;

            case 12:
              _context2.prev = 12;
              controller.clear();
              return _context2.finish(12);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 8, 12, 15]]);
    }))();
  };
}

exports.withTimeoutOption = withTimeoutOption;